import React from "react";

export default function FollowUpCard({ message, summary, topic }) {
  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">
      <p className="text-lg font-semibold text-yellow-800">{message}</p>
      <p className="text-sm text-gray-700 mt-1">{summary}</p>
      <span className="inline-block mt-2 px-3 py-1 text-xs font-medium bg-yellow-200 text-yellow-800 rounded-full">
        {topic}
      </span>
    </div>
  );
}
